import { isEmpty, get, unset, isArray, set } from 'lodash-es';
import { Subscription, fromEvent } from 'rxjs';
import { __decorate, __metadata } from 'tslib';
import { DOCUMENT, CommonModule } from '@angular/common';
import * as i0 from '@angular/core';
import { Injectable, Inject, EventEmitter, ChangeDetectorRef, ElementRef, Renderer2, ViewContainerRef, Directive, Output, Component, ChangeDetectionStrategy, Input, NgModule } from '@angular/core';
import * as i24 from '@angular/router';
import { NavigationEnd, Router, ActivatedRoute } from '@angular/router';
import * as i21 from '@upr-web-primer/card-promotion';
import { CardPromotionService } from '@upr-web-primer/card-promotion';
import * as i3 from '@upr-web-primer/digital-data';
import { DigitalDataService } from '@upr-web-primer/digital-data';
import * as i1 from '@upr-web-primer/gds-button-events';
import { GdsButtonEventsService, GdsButtonEventsModule } from '@upr-web-primer/gds-button-events';
import * as i2 from '@upr-web-primer/gds-button-model-service';
import { GdsButtonModelService } from '@upr-web-primer/gds-button-model-service';
import * as i20 from '@upr-web-primer/gds-calendar';
import { CALENDAR_TRIGGER_EVENT_KEYS, CALENDAR_OUTPUT_EVENT_KEYS, GdsCalendarEventDayService, GdsCalendarBlockoutDateService, GdsCalendarModule } from '@upr-web-primer/gds-calendar';
import * as i18 from '@upr-web-primer/gds-common-utility';
import { GdsCommonUtilityService, GdsCommonUtilityModule } from '@upr-web-primer/gds-common-utility';
import * as i27 from '@upr-web-primer/gds-comparison-table';
import { GdsComparisonTableService, GdsComparisonTableModule } from '@upr-web-primer/gds-comparison-table';
import * as i4 from '@upr-web-primer/gds-data-model';
import { GdsDataModelService } from '@upr-web-primer/gds-data-model';
import * as i5 from '@upr-web-primer/gds-filter-list';
import { GdsFilterListService } from '@upr-web-primer/gds-filter-list';
import * as i25 from '@upr-web-primer/gds-input-form';
import { GdsInputFormComponent, GdsInputFormService, GdsInputFormModule } from '@upr-web-primer/gds-input-form';
import * as i26 from '@upr-web-primer/gds-interactive-map';
import { GdsMapInteractiveComponent, GdsInteractiveMapService, GdsInteractiveMapModule } from '@upr-web-primer/gds-interactive-map';
import * as i6 from '@upr-web-primer/gds-modal';
import { GdsModalService } from '@upr-web-primer/gds-modal';
import * as i14 from '@upr-web-primer/gds-picture-model';
import { GdsPictureModelService } from '@upr-web-primer/gds-picture-model';
import * as i7 from '@upr-web-primer/gds-poi';
import { GdsPoiService } from '@upr-web-primer/gds-poi';
import * as i15 from '@upr-web-primer/gds-route-resolver';
import { GdsRouteResolverService } from '@upr-web-primer/gds-route-resolver';
import * as i16 from '@upr-web-primer/gds-state-service';
import { GdsStateService } from '@upr-web-primer/gds-state-service';
import * as i17 from '@upr-web-primer/gds-trip-advisor';
import { GdsTripAdvisorService, GdsTripAdvisorModule } from '@upr-web-primer/gds-trip-advisor';
import * as i8 from '@upr-web-primer/geolocation';
import { GeolocationService } from '@upr-web-primer/geolocation';
import * as i10 from '@upr-web-primer/locale';
import { LocaleService } from '@upr-web-primer/locale';
import * as i9 from '@upr-web-primer/ms-guests';
import { MsGuestsService, MsGuestModule } from '@upr-web-primer/ms-guests';
import * as i13 from '@upr-web-primer/ms-personalization';
import { MsPersonalizationService, MsPersonalizationModule } from '@upr-web-primer/ms-personalization';
import * as i22 from '@upr-web-primer/notification';
import { NotificationService } from '@upr-web-primer/notification';
import * as i12 from '@upr-web-primer/page-labels';
import { PageLabelsResolver, PageLabelsModule } from '@upr-web-primer/page-labels';
import * as i23 from '@upr-web-primer/spinner';
import { SpinnerService } from '@upr-web-primer/spinner';
import * as i11 from '@upr-web-primer/storage';
import { LocalStorageService, StorageModule } from '@upr-web-primer/storage';
import { WINDOW } from '@upr-web-primer/window';
import { Settings, DateTime } from 'luxon';
import { themeCheck, AvailableGdsThemes } from '@upr-gds-web/components';
import { sendEvent, AutoSubscription } from '@upr-web-primer/app-utils';
import { GdsDynamicFormComponent } from '@upr-web-primer/gds-dynamic-form';
import { take, map, skip, distinctUntilChanged, filter } from 'rxjs/operators';

// Tools
// lodash
/**
 * Export Auto Subscription
 *
 * @constructor
 */
const _c0 = ["*"];
function UprAutoSubscription() {
  // Return decorator
  return constructor => {
    // Get original onInit method
    const onInit = constructor.prototype.ngOnInit;
    // Get original onDestroy method
    const onDestroy = constructor.prototype.ngOnDestroy;
    // If we got original ngOnDestroy
    if (typeof onDestroy === 'function') {
      // This function will create new Subscription instance
      const initFunction = () => {
        // Create new Subscription instance
        constructor.prototype['subscriptions'] = new Subscription();
      };
      // Create new Subscription instance
      initFunction();
      // Replace OnInit method
      constructor.prototype.ngOnInit = function (...args) {
        // Initialize onInit if no subscriptions exist
        if (isEmpty(this.subscriptions['_subscriptions'])) {
          this.subscriptions = new Subscription();
        }
        // If we got original onInit method
        if (onInit && typeof onInit === 'function') {
          // Handle original onInit method
          onInit.apply(this, args);
        }
      };
      // Replace OnDestroy method
      constructor.prototype.ngOnDestroy = function (...args) {
        // Unsubscribe all subscribers
        this.subscriptions.unsubscribe();
        // If we got original onDestroy method
        if (onDestroy && typeof onDestroy === 'function') {
          // Handle original onDestroy method
          onDestroy.apply(this, args);
        }
        // Create AGAIN new Subscription instance
        initFunction();
      };
      // Child class must have ngOnDestroy, even if empty
    } else {
      console.error('===========  ==========');
      // Throw error
      console.error(constructor.name + ' must have ngOnDestroy, even if empty (AutoSubscription)');
      console.error('===========  ==========');
    }
  };
}

/**
 * Injectable
 */
class UprGdsXpmService {
  constructor(document, appDefaults) {
    this.document = document;
    this.appDefaults = appDefaults;
  }
  initPageSettings(pageSettings, elRef, renderer) {
    if (!this.isXpmEnabled(pageSettings)) {
      return;
    }
    const xpmPage = {
      PageID: get(pageSettings, 'Id'),
      PageModified: get(pageSettings, 'RevisionDate'),
      PageTemplateID: get(pageSettings, 'Id'),
      PageTemplateModified: get(pageSettings, 'RevisionDate')
    };
    const comment = 'Page Settings: ' + JSON.stringify(xpmPage);
    const comment2 = renderer.createComment(comment);
    elRef.nativeElement.insertBefore(comment2, elRef.nativeElement.firstChild);
    const xpm = renderer.createElement('script');
    xpm.src = get(this.appDefaults, 'XPM_BASE') + get(this.appDefaults, 'XPM_PATH');
    xpm.type = 'text/javascript';
    renderer.appendChild(this.document.body, xpm);
  }
  initXpmCpSettings(cp, elRef, renderer) {
    try {
      const xpmCp = {
        ComponentID: get(cp, 'Component.Id'),
        ComponentModified: get(cp, 'Component.visionDate'),
        ComponentTemplateID: get(cp, 'ComponentTemplate.Id'),
        ComponentTemplateModified: get(cp, 'ComponentTemplate.RevisionDate'),
        IsRepositoryPublished: true
      };
      const comment = 'Start Component Presentation:' + JSON.stringify(xpmCp);
      const comment2 = renderer.createComment(comment);
      renderer.insertBefore(elRef, comment2, elRef.firstChild);
    } catch (ex) {
      console.log('XPM Error: with componentid' + get(cp, 'Component.Id') + 'and error' + ex);
    }
  }
  initXpmFieldsSettings(cp, elRef, renderer) {
    try {
      const gdsComponentEle = elRef && elRef.firstChild && elRef.firstChild.data && elRef.firstChild.data.startsWith('Start Component Presentation') && elRef.firstChild.nextElementSibling;
      if (!gdsComponentEle) {
        return;
      }
      const xpaths = gdsComponentEle.querySelectorAll('[data-xpath]');
      if (xpaths && xpaths.length > 0) {
        for (let i = 0; i < xpaths.length; i++) {
          const xpath = get(xpaths[i], 'dataset.xpath');
          if (xpath) {
            const xpathObj = {
              XPath: xpath
            };
            const comment = 'Start Component Field: ' + JSON.stringify(xpathObj);
            const comment2 = renderer.createComment(comment);
            xpaths[i].insertBefore(comment2, xpaths[i].firstChild);
          }
        }
      }
    } catch (ex) {
      console.log('XPM Error for fields: with componentid' + get(cp, 'Component.Id') + 'and error' + ex);
    }
  }
  isXpmEnabled(data) {
    const xpmEnabled = get(this.appDefaults, 'XPM_ENABLED');
    const xpmBase = get(this.appDefaults, 'XPM_BASE');
    const xpmPath = get(this.appDefaults, 'XPM_PATH');
    const xpmHostName = get(this.appDefaults, 'XPM_HOSTNAME');
    return !!xpmEnabled && !!xpmBase && !!xpmPath && data && xpmHostName !== this.document.location.hostname;
  }
  static {
    this.ɵfac = function UprGdsXpmService_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || UprGdsXpmService)(i0.ɵɵinject(DOCUMENT), i0.ɵɵinject('AppDefaults'));
    };
  }
  static {
    this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: UprGdsXpmService,
      factory: UprGdsXpmService.ɵfac,
      providedIn: 'root'
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(UprGdsXpmService, [{
    type: Injectable,
    args: [{
      providedIn: 'root'
    }]
  }], () => [{
    type: undefined,
    decorators: [{
      type: Inject,
      args: [DOCUMENT]
    }]
  }, {
    type: undefined,
    decorators: [{
      type: Inject,
      args: ['AppDefaults']
    }]
  }], null);
})();
let GdsLoaderDirective = class GdsLoaderDirective {
  constructor(window, document, appDefaults, relativeUrls, defaultValues, buttonEventService, buttonDataMapper, changeDetect, digitalDataService, element, gdsDataModelService, gdsFilterListService, gdsModalService, gdsPoiService, geoLocationService, guestService, localeService, localStorage, pageLabelsResolver, personalize, pictureService, renderer, routeResolver, state, tripAdvisor, utilities, viewContainerRef, xpmService, calendarEventService, calendarBlockoutDateService, cardPromotionService, notification, spinner, gdsInputFormService, gdsInteractiveMapService, gdsComparisonTableService) {
    this.window = window;
    this.document = document;
    this.appDefaults = appDefaults;
    this.relativeUrls = relativeUrls;
    this.defaultValues = defaultValues;
    this.buttonEventService = buttonEventService;
    this.buttonDataMapper = buttonDataMapper;
    this.changeDetect = changeDetect;
    this.digitalDataService = digitalDataService;
    this.element = element;
    this.gdsDataModelService = gdsDataModelService;
    this.gdsFilterListService = gdsFilterListService;
    this.gdsModalService = gdsModalService;
    this.gdsPoiService = gdsPoiService;
    this.geoLocationService = geoLocationService;
    this.guestService = guestService;
    this.localeService = localeService;
    this.localStorage = localStorage;
    this.pageLabelsResolver = pageLabelsResolver;
    this.personalize = personalize;
    this.pictureService = pictureService;
    this.renderer = renderer;
    this.routeResolver = routeResolver;
    this.state = state;
    this.tripAdvisor = tripAdvisor;
    this.utilities = utilities;
    this.viewContainerRef = viewContainerRef;
    this.xpmService = xpmService;
    this.calendarEventService = calendarEventService;
    this.calendarBlockoutDateService = calendarBlockoutDateService;
    this.cardPromotionService = cardPromotionService;
    this.notification = notification;
    this.spinner = spinner;
    this.gdsInputFormService = gdsInputFormService;
    this.gdsInteractiveMapService = gdsInteractiveMapService;
    this.gdsComparisonTableService = gdsComparisonTableService;
    /**
     * outputs the event data to the parent component
     * exclusively used for cf3-input dynamic form
     * @type {EventEmitter<any>}
     */
    this.formOutput = new EventEmitter();
    this.loaded = false;
    this.contentType = 'static';
    this.firstDynamicContentLoad = true;
    /**
     * this event handler sets contrast in localStorage
     * @param {any} event
     * @returns void
     */
    this.contrastEventHandler = event => {
      const contrast = get(event, 'detail');
      this.localStorage.setItem('contrast', contrast);
    };
    this.componentLoadedHandler = data => {
      //component xpm tags
      if (this.xpmService.isXpmEnabled(data)) {
        this.xpmService.initXpmCpSettings(data, this.element.nativeElement.firstChild, this.renderer);
        this.xpmService.initXpmFieldsSettings(data, this.element.nativeElement.firstChild, this.renderer);
      }
      if (this.loaded) return;
      this.state.incrementComponentsLoaded();
      this.loaded = true;
    };
    /**
     * this event handler sets contrast in localStorage
     * @param {any} event
     * @returns void
     */
    this.reduceMotionHandler = event => {
      const reduceMotionEnabled = get(event, 'detail');
      this.localStorage.setItem('reduce_motion_enabled', reduceMotionEnabled);
    };
    if (this.pageLabelsResolver) {
      this.pageLabelsResolver.$pageLabels.pipe(take(1)).subscribe(pageLabels => {
        this.pageLabels = pageLabels;
      });
    }
    if (this.localeService) {
      const locale = this.localeService.getFromStorage();
      const language = locale?.language;
      const country = locale?.country?.toUpperCase();
      this.dateFormatPerLocale = `${language}-${country}`;
    }
    Settings.defaultZone = this.appDefaults.UPR_TIME_ZONE;
    const locale = this.localeService.getFromUrl();
    this.locale = `${locale.language}-${locale.country}`;
  }
  setComponentData(gdsComponent, data) {
    if (!!gdsComponent && !!data) {
      gdsComponent.data = data;
      return gdsComponent;
    }
    return;
  }
  /**
   * Renders the component by appending it to the DOM
   * @param {any} gdsComponent
   * @public
   * @returns void
   * @memberof GdsLoaderDirective
   **/
  renderComponent(gdsComponent) {
    if (!!gdsComponent) {
      const uid = this.utilities.uid();
      gdsComponent.setAttribute('uid', uid);
      this.renderer.setAttribute(this.element.nativeElement, 'uid', uid);
      if (this.componentIndex != undefined && this.element.nativeElement.children.length >= this.componentIndex + 1) {
        const nextTo = this.element.nativeElement.children[this.componentIndex];
        this.renderer.insertBefore(this.element.nativeElement, gdsComponent, nextTo);
        return;
      }
      this.renderer.appendChild(this.element.nativeElement, gdsComponent);
    }
  }
  /**
   * Extracts review id from the component content to be used in the reviews modal
   * @param {any} gdsComponentContent
   * @returns void
   * @memberof GdsLoaderDirective
   * @method extractReviewId
   * @public
   **/
  getReviewId(gdsComponentContent) {
    this.reviewId = get(gdsComponentContent, 'ratingsReview.advisorUnq') || get(gdsComponentContent, 'reviewSection.advisorUnq');
    gdsComponentContent = this.tripAdvisor.getLocationReviews(gdsComponentContent);
  }
  // Listeners && Handlers
  addContrastListener() {
    this.element.nativeElement.addEventListener('contrastSwitched', event => {
      this.contrastEventHandler(event);
    }, false);
  }
  addLoadedListener(data) {
    this.element.nativeElement.addEventListener('gdsComponentLoaded', () => {
      this.componentLoadedHandler(data);
    }, false);
  }
  addReduceMotionListener() {
    this.element.nativeElement.addEventListener('reduceMotionToggled', event => {
      this.reduceMotionHandler(event);
    }, false);
  }
  /**
   * adds event listenier to the gds component
   * @param {any} content - any
   * @param {string} contentType - string - as dynamic or tridion.
   * @returns None
   */
  addListener(content, contentType) {
    this.element.nativeElement.addEventListener('buttonClicked', event => {
      this.buttonEventService.buttonClickHandler(event, {
        content,
        contentType,
        theme: this.theme,
        viewContainerRef: this.viewContainerRef
      });
      event.stopImmediatePropagation();
    }, false);
  }
  /**
   * Remove the event listener from the button.
   * @returns None
   */
  removeListener() {
    this.element.nativeElement.removeEventListener('buttonClicked', this.buttonEventService.buttonClickHandler);
  }
  /**
   * * Get the input data from the GDS component and append it to the component.
   * @param {any} gdsComponentContent - the component content object
   * @param {any} gdsComponent - the component to render
   * @returns None
   */
  getCf3Input(gdsComponentContent, gdsComponent) {
    const inputData = {
      gdsInputs: get(gdsComponentContent, 'articleInput.GdsInputData') || get(gdsComponentContent, 'articleInput[0].GdsInputData'),
      contrast: this.contrast,
      theme: this.theme,
      pageLabels: this.pageLabels,
      visaCardValidity: get(gdsComponentContent, 'visaCardValidity', false)
    };
    unset(gdsComponentContent, 'articleInput.GdsInputData');
    unset(gdsComponentContent, 'buttons');
    this.setComponentData(gdsComponent, gdsComponentContent);
    this.renderComponent(gdsComponent);
    this.appendAsChild(gdsComponent, inputData);
  }
  /**
   * * Parse and clean data from gds-comparison-table component.
   * @param {TcmComparisonTable} gdsComponentContent - the Tridion component data being used to render the comparison table
   * @param {HTMLGdsComparisonTableElement} gdsComponent - the element being rendered on the DOM
   * @returns void
   */
  setComparisonTableData(gdsComponentContent, gdsComponent) {
    this.gdsComparisonTableService.setComparisonTableData(gdsComponentContent, gdsComponent);
  }
  /**
   * * Parse and clean data from gds-accordion-tree component.
   * @param {any} accordionTreeComponent - any - the component that is being used to render the accordion tree
   * @returns A reference to the accordion tree component that was created.
   */
  setAccordionTreeData(accordionTreeComponent) {
    if (!accordionTreeComponent.data.resources) {
      accordionTreeComponent.data.resources = {};
    }
    const resources = accordionTreeComponent?.data?.resources;
    ['ATExpandAll', 'ATCollapseAll'].forEach(key => {
      accordionTreeComponent.data.resources[key] = this.getResourceValue(resources, key);
    });
    const accordionTreeItems = get(accordionTreeComponent, 'data.accordionTreeItems', []);
    accordionTreeItems.forEach(item => {
      const itemQuestions = get(item, 'questions', []);
      if (!isArray(itemQuestions) && typeof itemQuestions === 'object') {
        set(item, 'questions', [{
          ...itemQuestions
        }]);
      }
    });
    delete accordionTreeComponent?.data?.resources?.Resource;
  }
  /**
   * * Get value from resources from Tridion and use page labels as fallback.
   * @param {any[]} resources - array of resources to search
   * @param {string} key - key to search for in resources array
   * @returns {string} the string value of the found resource.
   */
  getResourceValue(resources, key) {
    return (resources?.length ? resources?.find(resource => resource.Key === key)?.Value : this.pageLabels[key]) || '';
  }
  /**
   * * Create a new component instance and append it to the DOM.
   * @param {any} gdsComponent - any - the component that is being used to render the form
   * @param {any} data - the data object to be passed to the component
   * @returns A reference to the component that was created.
   */
  appendAsChild(gdsComponent, data) {
    const isVisaCardValidity = get(data, 'visaCardValidity', false);
    const componentRef = this.viewContainerRef.createComponent(GdsDynamicFormComponent);
    if (!componentRef) {
      console.error(`failed to create component`);
      return false;
    }
    componentRef.instance.data = data;
    componentRef.instance.contrast = this.contrast;
    componentRef.instance.theme = this.theme;
    if (isVisaCardValidity) {
      this.subscriptions.add(componentRef.instance.inputPayLoad?.subscribe(payload => {
        const creditCardNumber = payload.formInputPrimary;
        const cardInfo = {
          payment_account_number: creditCardNumber,
          purchase_restriction: 'VISA'
        };
        this.cardPromotionService.validateCard(cardInfo).then(response => this.handleCardEligibilitySuccessResponse(response)).catch(error => this.handleCardEligibilityErrorResponse(error)).finally(() => this.spinner.hide());
      }));
    } else {
      this.subscriptions.add(componentRef.instance.inputPayLoad?.subscribe(payload => {
        this.formOutput.emit(payload);
      }));
    }
    return this.renderer.appendChild(gdsComponent, componentRef.location.nativeElement);
  }
  handleCardEligibilitySuccessResponse(response) {
    const isCardEligible = get(response, 'is_eligible');
    if (!isCardEligible) {
      this.notification.show(this.pageLabels.VISA_VALID_FAILURE, 'error');
      return;
    }
    this.notification.show(this.pageLabels.VISA_VALID_SUCESS, 'success');
    setTimeout(() => {
      this.document.location.href = this.defaultValues.WHITE_LABEL_STORE_APP_PATH;
    }, 5000);
  }
  handleCardEligibilityErrorResponse(error) {
    const status = get(error, 'status_code') || get(error, 'status') || '';
    if (status === 400) {
      return this.notification.show(this.pageLabels.ER_144, 'error');
    } else if (status === 500) {
      return this.notification.show(this.pageLabels.ER71, 'error');
    }
  }
  /**
   * to detect changes happened in the dom
   * @returns void
   */
  ngAfterViewInit() {
    this.changeDetect.detectChanges();
  }
  /**
   * Sets template attributes for the component
   * @param {data} any - data object
   * @param {gdsComponent} any - component
   * @param {templateAttributes} [any] - template attributes
   * @returns gdsComponent
   * @memberof GdsLoaderComponent
   * @public
   **/
  setComponentAttributes(data, gdsComponent, templateAttributes) {
    if (!!templateAttributes && templateAttributes.length) {
      templateAttributes.forEach(keyValue => {
        if (keyValue) {
          const _key = get(keyValue, 'key.Values[0]');
          const _value = get(keyValue, 'value.Values[0]');
          if (_value !== '{{data}}') {
            if (_key === 'type') {
              this.gdsTemplateType = _value;
            }
            gdsComponent.setAttribute(_key, _value);
          }
        }
      });
    }
    this.contrast = this.utilities.getContrast();
    gdsComponent.setAttribute('contrast', this.contrast);
    this.theme = themeCheck(get(data, 'theme', AvailableGdsThemes[0]));
    if (this.theme) {
      gdsComponent.setAttribute('theme', this.theme);
    }
    this.hashId = this.routeResolver.getHashId(data);
    gdsComponent.setAttribute('data-hash-id', this.hashId);
    if (this.uId) {
      gdsComponent.setAttribute('id', this.uId);
    }
    return gdsComponent;
  }
  displayFallBackItems(gdsComponent, componentFallBackContent) {
    this.contentType = 'static';
    set(componentFallBackContent, 'items', this.filterSwimlaneItems(get(componentFallBackContent, 'items', [])));
    gdsComponent.items = componentFallBackContent.items;
    this.displayContentIds(gdsComponent, componentFallBackContent);
  }
  determineContent(gdsComponent, gdsComponentContent, tcmData, index) {
    this.tcmData = tcmData;
    this.componentIndex = index;
    const fallBackContent = {
      ...gdsComponentContent
    };
    const items = [].concat(get(gdsComponentContent, 'items'));
    const tcmIDs = [].concat(get(tcmData, 'Component.Fields.items.Values'));
    items?.forEach((_item, index) => {
      items[index].tcmId = tcmIDs[index];
    });
    if (gdsComponent.tagName.toLowerCase() === 'gds-swimlane') {
      this.localStorage.setItem('gds-swim-lane-content', items);
    }
    if (items.some(item => 'Persona' in item)) {
      const filteredItems = this.geoLocationService.filterByTcmPersona(items);
      gdsComponentContent.items = filteredItems;
      this.loadDynamicContent(gdsComponent, gdsComponentContent);
    } else {
      this.displayStaticContent(gdsComponent, gdsComponentContent);
    }
    if (items.some(item => 'Persona' in item)) {
      const geoToggle$ = this.geoLocationService.geoLocation$.pipe(map(() => true));
      this.subscriptions.add(geoToggle$.pipe(skip(1)).subscribe(() => {
        const filteredItems = this.geoLocationService.filterByTcmPersona(fallBackContent.items);
        const filteredFallBackContent = {
          ...fallBackContent,
          items: filteredItems
        };
        this.loadDynamicContent(gdsComponent, filteredFallBackContent);
      }));
    } else {
      this.displayContentIds(gdsComponent, gdsComponentContent);
    }
  }
  loadDynamicContent(gdsComponent, gdsComponentContent) {
    this.contentType = 'dynamic';
    this.setSwimlaneItems(gdsComponentContent, gdsComponent);
  }
  displayStaticContent(gdsComponent, staticContent) {
    this.contentType = 'static';
    set(staticContent, 'items', this.filterSwimlaneItems(get(staticContent, 'items', [])));
    this.setSwimlaneItems(staticContent, gdsComponent);
    this.displayContentIds(gdsComponent, staticContent);
  }
  logDDLerror() {
    const contentId = get(this.tcmData, 'Component.MetadataFields.contentId.Values[0]') || get(this.tcmData, 'component.contentId');
    this.digitalDataService.logEvent(false, 'Personalization Error', 'Error', contentId, 'ContentQty');
  }
  /**
   * Filters out swimlane items 'card-type' with parent 'card-type'
   * @param {data} any - data object
   * @param {items} any - items
   * @returns any
   * @memberof GdsLoaderComponent
   * @public
   **/
  filterSwimlaneItems(items) {
    const cardType = get(this.tcmData, 'Component.MetadataFields.card_type.KeywordValues[0].Key') || get(this.tcmData, 'component.card_type') || get(this.tcmData, 'component.0.card_type') || get(this.tcmData, 'card_type');
    const cards = items?.filter(item => cardType === item.card_type);
    if (!cards || cards.length < 2) {
      this.logDDLerror();
      return [];
    }
    return cards;
  }
  // tiny helper to return interact info
  returnInteractInfo(item) {
    if (!!item) {
      return {
        contentId: item.contentId,
        inbound_response_type_code: item.inbound_response_type_code,
        ip: item.ip,
        name: item.name,
        session_id: item.session_id,
        treatment_code: item.treatment_code,
        type_code: item.type_code
      };
    }
  }
  getRelatedTiles(content, component) {
    this.subscriptions.add(this.gdsPoiService.relatedTiles$.pipe(distinctUntilChanged()).subscribe(data => {
      if (!data) {
        return;
      }
      content.items = data;
      component = this.setComponentData(component, content);
      this.renderComponent(component);
    }));
    this.gdsPoiService.getRelatedTiles(this.pagePath);
  }
  setSwimlaneItems(content, component) {
    if (!content) {
      return;
    }
    if (this.gdsTemplateType === 'gds-full-image-card') {
      this.getRelatedTiles(content, component);
    }
    if (this.gdsTemplateType === 'gds-content-feature-four-card' || content.card_type === 'content-feature') {
      const items = get(content, 'items');
      const nextButton = get(content, 'nextButton');
      const previousButton = get(content, 'previousButton');
      set(content, 'swimlane[nextButton]', nextButton);
      unset(content, 'nextButton');
      set(content, 'swimlane[previousButton]', previousButton);
      unset(content, 'previousButton');
      if (!!items && items.length > 0) {
        items.forEach(item => {
          if (!!get(item, 'buttons')) {
            if (this.contentType === 'dynamic') {
              const btnData = this.buttonDataMapper.mapButtonData(get(item, 'buttons'));
              set(item, 'button', btnData[0] || btnData);
              Object.assign(get(item, 'button', {}), this.returnInteractInfo(item));
            } else {
              set(item, 'button', item.buttons[0]);
            }
            unset(item, 'buttons');
          }
          const rawImg = get(item, 'image') || get(item, 'backgroundImage');
          set(item, 'image', rawImg);
          if (!!rawImg && this.contentType === 'dynamic') {
            const img = this.pictureService.init(rawImg[0] || rawImg);
            set(item, 'image', img);
          }
        });
        set(content, 'swimlane[items]', items);
        unset(content, 'items');
      }
    }
    if (this.gdsTemplateType === 'gds-full-image-card-static' || content.card_type === 'full-image-card') {
      this.componentTemplate = 'gds-full-image-card';
      component.setAttribute('type', this.componentTemplate);
      if (this.contentType === 'dynamic') {
        const items = get(content, 'items');
        items.forEach(item => {
          if (!!get(item, 'background[0].image')) {
            set(item, 'background.image', this.pictureService.init(item.background[0].image[0]));
            unset(item, 'image');
          }
          if (!!get(item, 'background[0].link')) {
            set(item, 'background.link', this.buttonDataMapper.mapButtonData(get(item, 'background[0].link')));
          }
          unset(item, 'background[0]');
        });
      }
    }
    if (this.contentType === 'dynamic') {
      content = this.gdsDataModelService.parseContent(content);
      const childItems = get(content, 'items', []);
      if (this.gdsTemplateType === 'gds-info-card' || content.card_type === 'info-card') {
        if (isArray(childItems)) {
          childItems.forEach(childItem => {
            const cta = get(childItem, 'ctaButton');
            if (!!cta) {
              Object.assign(childItem.ctaButton, this.returnInteractInfo(childItem));
            }
          });
        }
      }
      if (this.gdsTemplateType === 'gds-offer-card' || content.card_type === 'offer-card') {
        if (isArray(childItems)) {
          childItems.forEach(childItem => {
            const ctaList = get(childItem, 'buttons', []);
            if (!!ctaList) {
              for (const btn of ctaList) {
                Object.assign(btn, this.returnInteractInfo(childItem));
              }
            }
          });
        }
      }
    }
    component = this.setComponentData(component, content);
    this.renderComponent(component);
    this.firstDynamicContentLoad = false;
  }
  /**
   * Get the hours for the current venue and update the component
   * hashTag with the correct hours
   * @param {any} gdsComponentContent - gds component content
   * @param {any} gdsComponent - component element that will be rendered.
   */
  getUpdatedHours(gdsComponentContent, gdsComponent) {
    this.gdsPoiService.isReady.pipe(filter(val => val === true), take(1)).subscribe(async () => {
      gdsComponentContent = await this.gdsPoiService.getHours(gdsComponentContent);
      gdsComponent = this.setComponentData(gdsComponent, gdsComponentContent);
      this.renderComponent(gdsComponent);
    });
  }
  getDate(dateStr, startOrEnd = '', defaultMonthsAhead = 1) {
    const today = DateTime.now();
    const eventDate = DateTime.fromFormat(dateStr, 'M/d/y');
    if (!eventDate.isValid) {
      if (startOrEnd === 'end') {
        return today.plus({
          months: defaultMonthsAhead
        }).toISO();
      }
      return today.toISO();
    }
    const isPast = eventDate < today;
    const resultDate = startOrEnd === 'end' ? isPast ? today.plus({
      months: defaultMonthsAhead
    }) : eventDate : isPast ? today : eventDate;
    return resultDate.toISO();
  }
  getMonthsBetweenDates(startDate, endDate) {
    return Math.floor(DateTime.fromISO(endDate).diff(DateTime.fromISO(startDate), 'months').months + 1);
  }
  setCalendarData(gdsComponentContent, gdsComponent) {
    const missingDates = [];
    const startDate = get(gdsComponentContent, 'start_date[0]', '')?.split(' ')[0];
    const endDate = get(gdsComponentContent, 'end_date[0]', '')?.split(' ')[0];
    if (!startDate) missingDates.push('start_date');
    if (!endDate) missingDates.push('end_date');
    if (missingDates.length) {
      console.error(`Calendar event missing ${missingDates.join(', ')}`);
      return;
    }
    this.eventStartDate = this.getDate(startDate);
    this.eventEndDate = this.getDate(endDate, 'end');
    set(gdsComponentContent, 'start_date', this.eventStartDate);
    set(gdsComponentContent, 'end_date', this.eventEndDate);
    set(gdsComponentContent, 'timezone.zone', this.appDefaults.UPR_TIME_ZONE);
    set(gdsComponentContent, 'timezone.locale', this.locale);
    const months = this.getMonthsBetweenDates(this.eventStartDate, this.eventEndDate);
    this.getEventMonths(this.eventStartDate, this.eventEndDate, gdsComponentContent, months);
    this.addMonthSubscription(gdsComponent);
  }
  getEventMonths(startDate, endDate, item, monthCount) {
    sendEvent(CALENDAR_TRIGGER_EVENT_KEYS.GET_MONTH_EVENTS, {
      startDate,
      endDate,
      zone: this.appDefaults.UPR_TIME_ZONE,
      item,
      monthCount
    });
  }
  addMonthSubscription(gdsComponent) {
    const eventMonths = fromEvent(this.window, CALENDAR_OUTPUT_EVENT_KEYS.OUT_GET_MONTH_EVENTS).pipe(take(1)).subscribe(data => {
      if (isEmpty(data?.detail?.months)) return;
      const calendarInfo = data?.detail;
      gdsComponent.requested = calendarInfo?.months;
    });
    this.subscriptions.add(eventMonths);
  }
  setParkHoursCalendarData(gdsComponentContent, gdsComponent, content) {
    const startDate = get(gdsComponentContent, 'start_date[0]', '')?.split(' ')[0];
    const endDate = get(gdsComponentContent, 'end_date[0]', '')?.split(' ')[0];
    const parkHoursStartDate = this.getDate(startDate);
    const parkHoursEndDate = this.getDate(endDate, 'end', 12);
    const rawBlocksDataContent = get(content, 'calendarBlockContainer.LinkedComponentValues[0].Fields.blocksData.LinkedComponentValues', []);
    const blocksData = get(gdsComponentContent, 'calendarBlockContainer.blocksData', []);
    const blocksDataArray = blocksData && !Array.isArray(blocksData) ? [blocksData] : blocksData;
    let parsedBlocksData = [];
    if (Array.isArray(blocksDataArray)) {
      parsedBlocksData = blocksDataArray.map((block, index) => {
        const metadata = get(rawBlocksDataContent, [index, 'MetadataFields'], {});
        const metadataFields = {};
        Object.entries(metadata).forEach(([key, data]) => {
          const keywords = get(data, 'KeywordValues', []);
          let value = get(data, 'Values[0]');
          if (keywords.length > 0) {
            value = get(keywords, '[0].Key');
          }
          metadataFields[key] = value;
        });
        return {
          ...block,
          ...metadataFields
        };
      });
    }
    set(gdsComponentContent, 'calendarBlockContainer.blocksData', parsedBlocksData);
    set(gdsComponentContent, 'start_date', parkHoursStartDate);
    set(gdsComponentContent, 'end_date', parkHoursEndDate);
    set(gdsComponentContent, 'timezone.zone', this.appDefaults.UPR_TIME_ZONE);
    set(gdsComponentContent, 'timezone.locale', this.locale);
    const months = this.getMonthsBetweenDates(parkHoursStartDate, parkHoursEndDate);
    this.getParkHoursMonths(parkHoursStartDate, parkHoursEndDate, gdsComponentContent, months);
    this.addParkHoursMonthSubscription(gdsComponent);
  }
  getParkHoursMonths(startDate, endDate, item, monthCount) {
    sendEvent(CALENDAR_TRIGGER_EVENT_KEYS.GET_MONTH_PARK_HOURS, {
      startDate,
      endDate,
      zone: this.appDefaults.UPR_TIME_ZONE,
      item,
      monthCount
    });
  }
  addParkHoursMonthSubscription(gdsComponent) {
    const eventMonths = fromEvent(this.window, CALENDAR_OUTPUT_EVENT_KEYS.OUT_GET_MONTH_PARK_HOURS).pipe(take(1)).subscribe(data => {
      if (isEmpty(data?.detail?.months)) return;
      const calendarDetail = data?.detail;
      const calendarInfo = calendarDetail?.info;
      const preSelectedDate = calendarInfo?.data?.firstAvailableDate ?? DateTime.now().setZone(this.appDefaults.UPR_TIME_ZONE);
      gdsComponent.preSelectedDate = preSelectedDate.toFormat('yyyy-MM-dd');
      gdsComponent.info = calendarInfo;
      gdsComponent.requested = calendarDetail?.months;
    });
    this.subscriptions.add(eventMonths);
  }
  setBlockoutDateCalendarData(gdsComponentContent, gdsComponent) {
    const rawResources = get(gdsComponentContent, 'resources', null);
    const resources = Array.isArray(rawResources) ? rawResources[0] : rawResources;
    const formattedResources = get(resources, 'Resource', []).reduce((data, resource) => {
      data[resource.Key?.toLowerCase()] = resource.Value;
      return data;
    }, {});
    const rawStartDate = get(gdsComponentContent, 'startDate', '');
    const startDate = (Array.isArray(rawStartDate) ? rawStartDate[0] : rawStartDate)?.split(' ')[0];
    const rawEndDate = get(gdsComponentContent, 'endDate', '');
    const endDate = (Array.isArray(rawEndDate) ? rawEndDate[0] : rawEndDate)?.split(' ')[0];
    const monthsToDisplay = Number(get(gdsComponentContent, 'monthsToDisplay', 0));
    const rawErrorDetail = get(gdsComponentContent, 'errorDetail', null);
    const errorDetail = Array.isArray(rawErrorDetail) ? rawErrorDetail[0] : rawErrorDetail;
    const blockoutDateStartDate = this.getDate(startDate);
    const endDateFallback = monthsToDisplay || 13;
    const blockoutDateEndDate = this.getDate(endDate, 'end', endDateFallback);
    const parsedDropdowns = [];
    const rawPassTypeData = get(gdsComponentContent, 'passType', null);
    const passTypeData = Array.isArray(rawPassTypeData) ? rawPassTypeData[0] : rawPassTypeData;
    const rawPassTypeValues = get(passTypeData, 'passTypeValues', []);
    let passTypeValues = rawPassTypeValues;
    if (!Array.isArray(rawPassTypeValues) && typeof rawPassTypeValues === 'object') {
      passTypeValues = [rawPassTypeValues];
    } else if (typeof passTypeValues === 'string') {
      passTypeValues = rawPassTypeValues.split(',');
    }
    const calendarUrls = {};
    let passId = get(passTypeData, 'defaultValue.Key', null) || get(passTypeData, 'defaultValue', null);
    if (rawPassTypeValues && passTypeValues.length > 0) {
      const passTypeTitle = get(passTypeData, 'passTypeTitle', '');
      const options = passTypeValues.map(opt => {
        if (typeof opt === 'string') {
          const resourceKey = `pass${opt.toLowerCase()}`;
          return {
            label: get(formattedResources, [resourceKey]) || get(this.pageLabels, [resourceKey]) || opt,
            value: opt
          };
        }
        const key = get(opt, 'Key', '');
        calendarUrls[key] = get(opt, 'MetadataFields.GoogleApi.Values[0]', '');
        return {
          label: get(opt, 'Description', ''),
          value: key
        };
      });
      if (!passId) {
        passId = options[0].value;
      }
      const dropdownData = {
        data: {
          formField: {
            primaryLabel: passTypeTitle
          },
          options
        },
        defaultValue: passId
      };
      set(dropdownData, 'data.type', 'pass-type');
      parsedDropdowns.push(dropdownData);
    }
    const rawParkTypeData = get(gdsComponentContent, 'parkType', null);
    const parkTypeData = Array.isArray(rawParkTypeData) ? rawParkTypeData[0] : rawParkTypeData;
    const rawParkTypeValues = get(parkTypeData, 'passTypeValues', []);
    let parkTypeValues = rawParkTypeValues;
    if (!Array.isArray(rawParkTypeValues) && typeof rawParkTypeValues === 'object') {
      parkTypeValues = [rawParkTypeValues];
    } else if (typeof parkTypeValues === 'string') {
      parkTypeValues = rawParkTypeValues.split(',');
    }
    let parkId = get(parkTypeData, 'defaultValue', '');
    if (rawParkTypeValues && parkTypeValues.length > 0) {
      const parkTypeTitle = get(parkTypeData, 'parkTypeTitle', '');
      const options = parkTypeValues.map(opt => {
        if (typeof opt === 'string') {
          return {
            label: get(formattedResources, [opt.toLowerCase()]) || get(this.pageLabels, [opt]) || opt,
            value: opt
          };
        }
        return {
          label: get(opt, 'Description', ''),
          value: get(opt, 'Key', '')
        };
      });
      if (!parkId) {
        parkId = options[0].value;
      }
      const dropdownData = {
        data: {
          formField: {
            primaryLabel: parkTypeTitle
          },
          options,
          type: 'park-type'
        },
        defaultValue: parkId
      };
      set(dropdownData, 'data.type', 'park-type');
      parsedDropdowns.push(dropdownData);
    }
    const rawKeyItems = get(gdsComponentContent, 'keyItem', []);
    const keyItems = Array.isArray(rawKeyItems) ? rawKeyItems : [rawKeyItems];
    const parsedKeyItems = keyItems.map(item => ({
      calendarDay: {
        style: item.dayStyle,
        date: {
          day: item.dayText
        }
      },
      description: item.keyDescription,
      key: item.calendarKeyword
    }));
    const key = {
      items: parsedKeyItems
    };
    set(gdsComponentContent, 'key', key);
    set(gdsComponentContent, 'dropdowns', parsedDropdowns);
    set(gdsComponentContent, 'timezone.zone', this.appDefaults.UPR_TIME_ZONE);
    set(gdsComponentContent, 'timezone.locale', this.locale);
    const monthsBetweenDates = this.getMonthsBetweenDates(blockoutDateStartDate, blockoutDateEndDate);
    const months = monthsToDisplay ? Math.min(monthsBetweenDates, monthsToDisplay) : monthsBetweenDates;
    const calendarItemData = {
      start_date: blockoutDateStartDate,
      end_date: blockoutDateEndDate,
      timezone: gdsComponentContent.timezone,
      park: {
        default: parkId
      },
      pass: {
        default: passId
      },
      calendarUrls,
      keyItems: parsedKeyItems,
      resources
    };
    const calendarRequestData = {
      startDate: blockoutDateStartDate,
      endDate: blockoutDateEndDate,
      zone: this.appDefaults.UPR_TIME_ZONE,
      item: calendarItemData,
      monthCount: months
    };
    gdsComponent.fullCalendarView = [true, 'true'].includes(get(gdsComponentContent, 'fullCalendarView', ''));
    this.calendarBlockoutDateService.initComponent(gdsComponent, calendarRequestData, parsedDropdowns, errorDetail);
  }
  displayContentIds(gdsComponent, gdsComponentContent) {
    let itemsData = [];
    if (get(this.tcmData, 'Component.Fields.displayContentId.KeywordValues[0].Key') === 'true' || get(this.tcmData, 'component.displayContentId') === 'true') {
      const data = get(gdsComponentContent, 'items') || get(gdsComponentContent, 'swimlane[items]');
      if (this.contentType === 'dynamic' && !!data) {
        itemsData = data.map(item => item.contentId);
      }
      itemsData = this.contentType === 'static' ? this.gdsDataModelService.fetchContentIds(get(this.tcmData, 'Component.Fields.items.LinkedComponentValues') || get(this.tcmData, 'component.items')) : itemsData;
      setTimeout(() => {
        const swimLaneItems = gdsComponent.querySelectorAll('li.dynamic-item');
        if (swimLaneItems.length > 0) {
          swimLaneItems.forEach((swimLaneItem, i) => {
            const pTag = document.createElement('p');
            const pTagContent = document.createTextNode('Content Id:' + itemsData[i]);
            pTag.appendChild(pTagContent);
            swimLaneItem.prepend(pTag);
          });
        }
      }, 2000);
    }
  }
  setXpmData(content, gdsComponent, data) {
    if (this.xpmService.isXpmEnabled(data)) {
      const xPathData = this.gdsDataModelService.initXpmFields(content);
      gdsComponent.xpath = xPathData;
    }
  }
  renderTextBlocks(content, gdsComponent, gdsComponentContent, data) {
    const isMenuBlocks = get(data, 'Component.Schema.RootElementName', '') === 'GDSTextMenuBlock';
    this.initTextBlockSections(gdsComponentContent, isMenuBlocks);
    this.setXpmData(content, gdsComponent, data);
    this.initTextBlockSections(gdsComponent?.xpath, isMenuBlocks);
    gdsComponentContent?.sections.forEach((section, index) => {
      const newGdsComponent = gdsComponent.cloneNode(true);
      newGdsComponent.xpath = get(gdsComponent, `xpath.sections[${index}]`, null);
      this.setComponentData(newGdsComponent, section);
      this.renderComponent(newGdsComponent);
    });
  }
  initTextBlockSections(content, isMenuBlocks) {
    if (!content) return;
    const sections = get(content, 'sections', []);
    if (!isArray(sections) && typeof sections === 'object') {
      set(content, 'sections', [{
        ...sections
      }]);
    } else {
      set(content, 'sections', sections);
    }
    content.sections.forEach(section => {
      const sectionHeading = get(section, 'heading', '');
      const items = get(section, 'items', []);
      set(section, 'heading', sectionHeading);
      if (!isArray(items) && typeof items === 'object') {
        set(section, 'items', [{
          ...items
        }]);
      } else {
        set(section, 'items', items);
      }
      const isMFO = get(section, 'items', []).some(item => !!item?.mfoItemCode);
      if (isMFO || isMenuBlocks) {
        section.items.forEach(item => {
          if (!isArray(item.featureList) && typeof item.featureList === 'object') {
            set(item, 'featureList', [{
              ...item.featureList
            }]);
          } else {
            set(item, 'featureList', item.featureList);
          }
          const items = get(item, 'featureList', []).map(icon => ({
            iconName: get(icon, 'Key', null),
            iconLabel: get(icon, 'MetadataFields.heading.Values[0]', null),
            ariaLabel: get(icon, 'MetadataFields.description.Values[0]', null)
          }));
          set(item, 'icons', items);
        });
      } else {
        section.items.forEach(item => {
          const icons = get(item, 'featureList.feature', []).map(icon => ({
            iconName: icon.icon,
            iconLabel: icon.heading,
            ariaLabel: get(icon, 'button.ariaLabel', null)
          }));
          set(item, 'icons', icons);
          unset(item, 'featureList');
        });
      }
    });
  }
  renderFilterList(filterListComponent) {
    this.gdsFilterListService.processFilters(filterListComponent);
  }
  renderInputForm(inputFormComponent) {
    this.gdsInputFormService.renderInputForm(inputFormComponent);
    this.addFormToSlot(inputFormComponent);
  }
  setCalloutFormData(calloutFormComponent, backgroundColor) {
    this.gdsInputFormService.setCalloutFormData(calloutFormComponent, backgroundColor);
  }
  addFormToSlot(inputFormComponent) {
    this.document.addEventListener('gdsFormContainerLoaded', () => {
      const gdsFormContainer = this.document.querySelector('.gds-form-container-slot');
      const gdsInputFormComponentRef = this.addCompToSlot(GdsInputFormComponent, gdsFormContainer);
      gdsInputFormComponentRef.instance.initForm(inputFormComponent, this.pageLabels);
    });
  }
  renderInteractiveMap(mapComponent) {
    const gdsMapComponentRef = this.addCompToSlot(GdsMapInteractiveComponent, this.element.nativeElement);
    gdsMapComponentRef.instance.data = mapComponent.data;
    gdsMapComponentRef.instance.pageView = true;
    gdsMapComponentRef.instance.theme = this.theme;
  }
  addMobileMapComponents(components) {
    this.element.nativeElement.addEventListener('gdsMapContainerLoaded', () => {
      const mobileContainer = this.element.nativeElement.querySelector('.gds-map-container-mobile');
      this.renderer.appendChild(mobileContainer, components);
    });
  }
  addCompToSlot(component, parentNode) {
    const componentRef = this.viewContainerRef.createComponent(component);
    this.renderer.appendChild(parentNode, componentRef.location.nativeElement);
    return componentRef;
  }
  setHeroCarouselContent(carouselComponent, content) {
    const _data = this.utilities.getComponentData(carouselComponent);
    const slides = [].concat(get(carouselComponent, 'data.slides', []));
    const carouselSlides = slides.map((slide, index) => {
      const mediaType = slide?.video ? 'video' : 'picture';
      let media;
      if (mediaType === 'video') {
        media = {
          ...get(slide, 'video', {}),
          tablet: get(slide, 'video.tablet') || get(slide, 'video.mobile'),
          image: get(slide, 'image', {})
        };
      } else {
        media = get(slide, 'image', {});
      }
      return {
        ...slide,
        mediaType,
        media,
        description: get(slide, 'body', ''),
        heading: get(slide, 'headline', ''),
        Persona: get(content, ['slides', 'LinkedComponentValues', index, 'MetadataFields', 'persona'], ''),
        heroSlideDuration: get(content, ['slides', 'LinkedComponentValues', index, 'MetadataFields', 'heroslideduration', 'NumericValues', 0], 0) * 1000,
        // duration in Tridion defined in seconds, swiper wants milliseconds
        tcmId: get(content, ['slides', 'LinkedComponentValues', index, 'Id'], '')
      };
    });
    this.subscriptions.add(this.geoLocationService.geoLocation$.subscribe(() => {
      const filteredCarouselSlides = this.geoLocationService.filterByTcmPersona(carouselSlides);
      const updatedSlides = filteredCarouselSlides.map((slide, index) => {
        const ariaLabel = get(slide, 'pagination.ariaLabel', '');
        if (!ariaLabel) return slide;
        const dynamicAriaLabel = this.utilities.replaceHashCodes(ariaLabel, {
          current: String(index + 1),
          total: filteredCarouselSlides.length.toString()
        });
        return {
          ...slide,
          pagination: {
            ...slide.pagination,
            ariaLabel: dynamicAriaLabel
          }
        };
      });
      set(_data, 'items', updatedSlides);
      carouselComponent.setAttribute('data', JSON.stringify(_data));
    }));
    const reducedMotionEnabled = this.localStorage.getItem('reduce_motion_enabled');
    if (reducedMotionEnabled === null) {
      this.localStorage.setItem('reduce_motion_enabled', get(_data, 'reduceMotion.initialToggle', false));
    } else {
      set(_data, 'reduceMotion.initialToggle', reducedMotionEnabled);
    }
    carouselComponent.setAttribute('data', JSON.stringify(_data));
  }
  ngOnDestroy() {
    this.element.nativeElement.removeEventListener('contrastSwitched', this.contrastEventHandler);
  }
  static {
    this.ɵfac = function GdsLoaderDirective_Factory(__ngFactoryType__) {
      i0.ɵɵinvalidFactory();
    };
  }
  static {
    this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: GdsLoaderDirective,
      outputs: {
        formOutput: "formOutput"
      }
    });
  }
};
GdsLoaderDirective = __decorate([AutoSubscription(), __metadata("design:paramtypes", [Object, Object, Object, Object, Object, GdsButtonEventsService, GdsButtonModelService, ChangeDetectorRef, DigitalDataService, ElementRef, GdsDataModelService, GdsFilterListService, GdsModalService, GdsPoiService, GeolocationService, MsGuestsService, LocaleService, LocalStorageService, PageLabelsResolver, MsPersonalizationService, GdsPictureModelService, Renderer2, GdsRouteResolverService, GdsStateService, GdsTripAdvisorService, GdsCommonUtilityService, ViewContainerRef, UprGdsXpmService, GdsCalendarEventDayService, GdsCalendarBlockoutDateService, CardPromotionService, NotificationService, SpinnerService, GdsInputFormService, GdsInteractiveMapService, GdsComparisonTableService])], GdsLoaderDirective);
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(GdsLoaderDirective, [{
    type: Directive
  }], () => [{
    type: undefined
  }, {
    type: undefined
  }, {
    type: undefined
  }, {
    type: undefined
  }, {
    type: undefined
  }, {
    type: i1.GdsButtonEventsService
  }, {
    type: i2.GdsButtonModelService
  }, {
    type: i0.ChangeDetectorRef
  }, {
    type: i3.DigitalDataService
  }, {
    type: i0.ElementRef
  }, {
    type: i4.GdsDataModelService
  }, {
    type: i5.GdsFilterListService
  }, {
    type: i6.GdsModalService
  }, {
    type: i7.GdsPoiService
  }, {
    type: i8.GeolocationService
  }, {
    type: i9.MsGuestsService
  }, {
    type: i10.LocaleService
  }, {
    type: i11.LocalStorageService
  }, {
    type: i12.PageLabelsResolver
  }, {
    type: i13.MsPersonalizationService
  }, {
    type: i14.GdsPictureModelService
  }, {
    type: i0.Renderer2
  }, {
    type: i15.GdsRouteResolverService
  }, {
    type: i16.GdsStateService
  }, {
    type: i17.GdsTripAdvisorService
  }, {
    type: i18.GdsCommonUtilityService
  }, {
    type: i0.ViewContainerRef
  }, {
    type: UprGdsXpmService
  }, {
    type: i20.GdsCalendarEventDayService
  }, {
    type: i20.GdsCalendarBlockoutDateService
  }, {
    type: i21.CardPromotionService
  }, {
    type: i22.NotificationService
  }, {
    type: i23.SpinnerService
  }, {
    type: i25.GdsInputFormService
  }, {
    type: i26.GdsInteractiveMapService
  }, {
    type: i27.GdsComparisonTableService
  }], {
    formOutput: [{
      type: Output
    }]
  });
})();
let GdsLoaderComponent = class GdsLoaderComponent extends GdsLoaderDirective {
  constructor(window, document, appDefaults, relativeUrls, defaultValues, buttonEventService, buttonDataMapper, changeDetect, digitalDataService, element, gdsDataModelService, gdsFilterListService, gdsModalService, gdsPoiService, geoLocationService, guestService, localeService, localStorage, pageLabelsResolver, personalize, pictureService, renderer, routeResolver, state, tripAdvisor, utilities, viewContainerRef, xpmService, calendarEventService, calendarBlockoutDateService, cardPromotionService, notification, spinner, router, route, gdsInputFormService, gdsInteractiveMapService, gdsComparisonTableService) {
    super(window, document, appDefaults, relativeUrls, defaultValues, buttonEventService, buttonDataMapper, changeDetect, digitalDataService, element, gdsDataModelService, gdsFilterListService, gdsModalService, gdsPoiService, geoLocationService, guestService, localeService, localStorage, pageLabelsResolver, personalize, pictureService, renderer, routeResolver, state, tripAdvisor, utilities, viewContainerRef, xpmService, calendarEventService, calendarBlockoutDateService, cardPromotionService, notification, spinner, gdsInputFormService, gdsInteractiveMapService, gdsComparisonTableService);
    this.router = router;
    this.route = route;
    this.loaded = false;
    // Url params observable
    this.subscriptions.add(this.route.data.subscribe(data => {
      this.pagePath = get(data, 'urlInfo.path', '');
    }));
    // Subscribe to Gds Components to Load
    this.subscriptions.add(this.state.componentsToLoad$.subscribe(count => {
      this.gdsComponentsToLoad = count;
    }));
    // Subscribe to Gds Components Loaded
    this.subscriptions.add(this.state.componentsLoaded$.subscribe(componentsLoaded => {
      if (this.gdsComponentsToLoad === componentsLoaded) {
        if (window.location.hash) {
          const hash = window.location.hash.substring(1);
          if (hash === this.hashId) {
            this.routeResolver.scrollTo(this.hashId, true);
          }
        }
      }
    }));
    // Subscribe to router navigation (when hash changes)
    // and scroll to it if window hash matches this.hashId
    this.subscriptions.add(this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        if (window.location.hash) {
          const hash = window.location.hash.substring(1);
          if (hash === this.hashId) {
            this.routeResolver.scrollTo(this.hashId, false);
          }
        }
      }
    }));
  }
  /**
   * on init
   */
  ngOnInit() {
    this.gdsTemplateName = get(this.data, 'ComponentTemplate.MetadataFields.name.Values[0]');
    // TODO: Reevaluate
    this.gdsTemplateName = this.gdsTemplateName === 'gds-image-info-section' && this.data?.pageTemplate === 'gds input form page template' ? 'gds-callout-form-container' : this.gdsTemplateName;
    const gdsComponent = this.document.createElement(this.gdsTemplateName);
    const dataComponentTemplate = get(this.data, 'ComponentTemplate');
    const dataComponent = get(this.data, 'Component');
    const content = get(this.data.Component, 'Fields');
    this.loadGdsComponent(gdsComponent, this.data, this.gdsTemplateName, dataComponentTemplate, dataComponent, content, false);
  }
  /**
   * Loads gds component
   */
  async loadGdsComponent(gdsComponent, data, gdsTemplateName, dataComponentTemplate, dataComponent, content, subComponent = false, subComponentIndex) {
    if (!content || !gdsTemplateName || !this.element || !this.element.nativeElement) {
      return;
    }
    let gdsComponentContent = subComponent ? content : this.gdsDataModelService.init(content);
    let uId;
    this.getReviewId(gdsComponentContent);
    gdsComponent = this.setComponentAttributes(data, gdsComponent, get(dataComponentTemplate, 'MetadataFields.attributes.EmbeddedValues'));
    if (gdsTemplateName === 'gds-contrast-switch') {
      this.addContrastListener();
    }
    if (!subComponent) {
      this.addListener(content, '');
    }
    this.addLoadedListener(data);
    if (['gds-park-hero', 'gds-map-card', 'gds-utility-section', 'gds-land-hero'].includes(gdsTemplateName)) {
      if (subComponent && subComponentIndex !== undefined) {
        this.componentIndex = subComponentIndex;
      }
      this.getUpdatedHours(gdsComponentContent, gdsComponent);
      return;
    }
    if (['gds-swimlane', 'gds-content-feature-four'].includes(gdsTemplateName)) {
      gdsComponentContent = this.determineContent(gdsComponent, gdsComponentContent, data);
      return;
    }
    if (['gds-article-detail', 'gds-hero', 'gds-cf5', 'gds-cf5-center', 'gds-cf5-title'].includes(gdsTemplateName)) {
      const tagType = get(dataComponent, 'MetadataFields.tagType.KeywordValues[0].Key', '');
      if (!!tagType) {
        gdsComponent.setAttribute('tag-type', tagType);
      }
    }
    if (gdsTemplateName === 'gds-immersive-gallery') {
      gdsComponent.setAttribute('animationDuration', this.appDefaults.ANIMATION_DURATION);
    }
    if (gdsTemplateName === 'gds-local-navigation') {
      const displayPageViewOnMobile = get(dataComponent, 'MetadataFields.displayPageViewOnMobile.KeywordValues[0].Key', '');
      if (!!displayPageViewOnMobile) {
        gdsComponent.setAttribute('display-page-view-on-mobile', displayPageViewOnMobile);
      }
      const doNotDisplayOnViewPortsKeywordValues = get(dataComponent, 'MetadataFields.doNotDisplayOnViewPorts.KeywordValues', []);
      const doNotDisplayOnViewPorts = doNotDisplayOnViewPortsKeywordValues.map(keywordValue => keywordValue.Key).join(',');
      if (!!doNotDisplayOnViewPorts) {
        gdsComponent.setAttribute('do-not-display-on-view-ports', doNotDisplayOnViewPorts);
      }
    }
    if (gdsTemplateName === 'gds-hero' && get(gdsComponentContent, 'video')) {
      this.getPosterImage(gdsComponentContent, gdsComponent);
      return;
    }
    const list = get(gdsComponentContent, 'items', '');
    if (list) set(gdsComponentContent, 'items', [].concat(list));
    if (gdsTemplateName === 'gds-event-day-calendar') {
      this.setCalendarData(gdsComponentContent, gdsComponent);
    }
    if (gdsTemplateName === 'gds-park-hours-calendar') {
      this.setParkHoursCalendarData(gdsComponentContent, gdsComponent, content);
    }
    if (gdsTemplateName === 'gds-blockout-date-calendar') {
      this.setBlockoutDateCalendarData(gdsComponentContent, gdsComponent);
      this.renderComponent(gdsComponent);
      return;
    }
    if (gdsTemplateName === 'gds-text-blocks') {
      this.renderTextBlocks(content, gdsComponent, gdsComponentContent, data);
      return;
    }
    gdsComponent = this.setComponentData(gdsComponent, gdsComponentContent);
    if (gdsTemplateName === 'gds-cf3-input') {
      this.getCf3Input(gdsComponentContent, gdsComponent);
      return;
    }
    if (gdsTemplateName === 'gds-article-detail') {
      const venueId = get(dataComponent, 'MetadataFields.venueId.Values[0]', '');
      const placeId = get(dataComponent, 'MetadataFields.placeId.Values[0]', '');
      this.gdsPoiService.getDiningHours(gdsComponent, venueId, placeId);
    }
    if (gdsTemplateName === 'gds-expanded-offer-detail') {
      ['featureGroup1', 'featureGroup2', 'featureGroup3'].forEach(item => {
        const list = get(gdsComponentContent, `${item}.feature`, '');
        if (list) {
          set(gdsComponentContent, `${item}.feature`, [].concat(list));
        }
      });
      const currency = this.digitalDataService.getCurrency();
      if (currency) {
        set(gdsComponentContent, 'offer.currency', currency);
      }
    }
    if (['gds-utility-section', 'gds-park-hero', 'gds-expanded-offer-detail'].includes(gdsTemplateName)) {
      this.tripAdvisor.getLocationReviews(gdsComponent);
    }
    if (gdsTemplateName === 'gds-flexible-container') {
      this.renderer.appendChild(this.element.nativeElement, gdsComponent);
      uId = this.utilities.uid();
      this.loadGroupedComponents(uId, content);
    }
    if (gdsTemplateName === 'gds-container') {
      const wrapper = this.document.createElement('div');
      wrapper.setAttribute('slot', 'gds-container-content');
      const containerData = this.utilities.getComponentData(gdsComponent);
      this.renderContainerComponents(containerData, gdsComponent, wrapper, {
        'font-color': gdsComponentContent.fontColor
      });
    }
    // Tabs
    if (gdsTemplateName === 'gds-tabs') {
      this.setTabsContent(gdsComponent);
    }
    // Comparison Table
    if (gdsTemplateName === 'gds-comparison-table') {
      this.setComparisonTableData(gdsComponentContent, gdsComponent);
    }
    // Accordion tree
    if (gdsTemplateName.toLocaleLowerCase() === 'gds-accordion-tree') {
      this.setAccordionTreeData(gdsComponent);
    }
    if (gdsTemplateName === 'gds-filter-list') {
      this.renderFilterList(gdsComponent);
    }
    if (gdsTemplateName === 'gds-callout-form-container') {
      this.setCalloutFormData(gdsComponent, data.backgroundColor);
    }
    if (gdsTemplateName === 'gds-form-container') {
      if (data.pageTemplate === 'gds input form page template') {
        this.renderInputForm(gdsComponent);
        return;
      } else {
        const formData = gdsComponent.data;
        this.gdsInputFormService.getServiceDetails(formData);
        gdsComponent.data = {
          ...formData,
          ...this.gdsInputFormService.setFormContainerData(formData)
        };
        this.addFormToSlot(gdsComponent);
      }
    }
    if (gdsTemplateName === 'gds-interactive-map') {
      this.renderInteractiveMap(gdsComponent);
      const mobileComponents = this.getIMapMobileComponents(gdsComponent);
      this.addMobileMapComponents(mobileComponents);
      return;
    }
    if (gdsTemplateName.toLocaleLowerCase() === 'gds-hero-carousel') {
      this.setHeroCarouselContent(gdsComponent, content);
      this.addReduceMotionListener();
    }
    if (gdsTemplateName === 'gds-cf6') {
      try {
        const timezone = get(this.appDefaults, 'UPR_TIME_ZONE', 'America/Los_Angeles');
        if (gdsComponentContent.heading) {
          const todaysDate = DateTime.now().setZone(timezone).toLocaleString(DateTime.DATE_FULL);
          gdsComponentContent.heading = gdsComponentContent.heading.replace('##LongDateFormat##', todaysDate);
        }
        const componentHasReplaceTokens = (gdsComponentContent.items || []).some(item => item.description?.includes('##parkhours##') || item.description?.includes('##EarlyEntryToOpenHours##'));
        if (componentHasReplaceTokens) {
          this.gdsPoiService.fetchVenueHours().subscribe(result => {
            result?.Results.forEach(venue => {
              const hours = get(venue, 'Hours', []);
              const hoursData = this.gdsPoiService.getTodaysHours(hours);
              const venueId = venue.Id;
              gdsComponentContent.items.forEach(item => {
                const id = item.VenueID;
                if (id && Number(id) === venueId && item.description) {
                  item.description = this.gdsPoiService.replaceVenueHoursHashCodes(item.description, hoursData, timezone);
                }
              });
            });
            gdsComponent = this.setComponentData(gdsComponent, gdsComponentContent);
            this.renderComponent(gdsComponent);
          }, error => {
            console.log('Error occurred while fetching venue hours', error);
            gdsComponentContent.items.forEach(item => {
              if (item.description) {
                item.description = item.description.replace('##parkhours##', ' ');
                item.description = item.description.replace('##EarlyEntryToOpenHours##', ' ');
              }
            });
            gdsComponent = this.setComponentData(gdsComponent, gdsComponentContent);
            this.renderComponent(gdsComponent);
          });
        } else {
          gdsComponent = this.setComponentData(gdsComponent, gdsComponentContent);
          this.renderComponent(gdsComponent);
        }
      } catch (e) {
        console.log('exception occurred', e);
        gdsComponent = this.setComponentData(gdsComponent, gdsComponentContent);
        this.renderComponent(gdsComponent);
      }
      return;
    }
    // xpm field xpath
    this.setXpmData(content, gdsComponent, data);
    this.renderComponent(gdsComponent);
  }
  getPosterImage(content, component) {
    const image = get(content, 'image', false);
    if (image) {
      set(content, 'video[image]', image);
      unset(content, 'image');
    }
    component = this.setComponentData(component, content);
    this.renderComponent(component);
  }
  loadGroupedComponents(uid, content) {
    const container = this.document.getElementById(uid);
    const cps = get(content, 'elements.EmbeddedValues');
    this.transcludeGdsComponents(this.data, container, cps);
  }
  transcludeGdsComponents(data, container, cps) {
    cps.forEach(cp => {
      const gdsTemplateName = get(cp, 'componentTemplate.KeywordValues[0].MetadataFields.name.Values[0]');
      const componentTemplate = get(cp, 'componentTemplate.KeywordValues[0].MetadataFields.attributes.EmbeddedValues[0].value.Values[0]');
      const componentContent = get(cp, 'component.LinkedComponentValues[0].Fields');
      if (!gdsTemplateName || !componentTemplate || !componentContent) {
        return;
      }
      const gdsComponentContent = this.gdsDataModelService.init(componentContent);
      let gdsComponent = this.document.createElement(gdsTemplateName);
      gdsComponent = this.setComponentAttributes(data, gdsComponent, get(cp, 'componentTemplate.KeywordValues[0].MetadataFields.attributes.EmbeddedValues'));
      container.appendChild(gdsComponent);
      if (['gds-utility-section', 'gds-map-card', 'gds-park-hero', 'gds-land-hero'].includes(gdsTemplateName)) {
        this.getUpdatedHours(gdsComponentContent, gdsComponent);
      }
    });
  }
  renderContainerComponents(content, parentComponent, wrapper, inheritedAttributes) {
    if (!isArray(content?.elements) && typeof content?.elements === 'object') {
      set(content, 'elements', [{
        ...content?.elements
      }]);
    } else {
      set(content, 'elements', content?.elements);
    }
    content?.elements?.forEach((element, index) => {
      const gdsTemplateName = get(element, 'componentTemplate.MetadataFields.name.Values[0]', '');
      if (!gdsTemplateName) return;
      const gdsComponent = this.document.createElement(gdsTemplateName);
      const data = element;
      data.theme = this.theme;
      if (inheritedAttributes) {
        Object.entries(inheritedAttributes).forEach(([key, val]) => {
          gdsComponent.setAttribute(key, val);
        });
      }
      const pseudoGdsLoader = Object.assign(Object.create(this), {
        element: {
          nativeElement: wrapper
        }
      });
      this.loadGdsComponent.call(pseudoGdsLoader, gdsComponent, data, gdsTemplateName, data.componentTemplate, data.component, data.component, true, index);
    });
    this.renderer.appendChild(parentComponent, wrapper);
  }
  /**
   * * Get the tabs data from the GDS component and append it to the component.
   * @param {any} tabsComponent - the component to render
   * @returns None
   */
  setTabsContent(tabsComponent) {
    const data = get(tabsComponent, 'data');
    data?.tabContents?.forEach(tabContent => {
      const wrapper = this.document.createElement('div');
      wrapper.setAttribute('id', 'tab-panel-' + tabContent.permaLink);
      wrapper.setAttribute('role', 'tabpanel');
      wrapper.classList.add('hidden');
      this.renderContainerComponents(tabContent, tabsComponent, wrapper);
    });
    delete tabsComponent.data?.tabContents?.elements;
  }
  getIMapMobileComponents(gdsMapComponent) {
    const wrapper = this.document.createElement('div');
    const mobileComponents = get(gdsMapComponent, 'data.mobileComponents', null);
    if (!isArray(mobileComponents?.elements) && typeof mobileComponents?.elements === 'object') {
      set(mobileComponents, 'elements', [{
        ...mobileComponents?.elements
      }]);
    } else {
      set(mobileComponents, 'elements', mobileComponents?.elements);
    }
    mobileComponents?.elements?.forEach((element, index) => {
      const gdsTemplateName = get(element, 'componentTemplate.MetadataFields.name.Values[0]', '');
      if (!gdsTemplateName) return;
      const gdsComponent = this.document.createElement(gdsTemplateName);
      const data = element;
      data.theme = this.theme;
      const pseudoGdsLoader = Object.assign(Object.create(this), {
        element: {
          nativeElement: wrapper
        }
      });
      this.loadGdsComponent.call(pseudoGdsLoader, gdsComponent, data, gdsTemplateName, data.componentTemplate, data.component, data.component, true, index);
    });
    return wrapper;
  }
  static {
    this.ɵfac = function GdsLoaderComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || GdsLoaderComponent)(i0.ɵɵdirectiveInject(WINDOW), i0.ɵɵdirectiveInject(DOCUMENT), i0.ɵɵdirectiveInject('AppDefaults'), i0.ɵɵdirectiveInject('RelativeUrls'), i0.ɵɵdirectiveInject('DefaultValues'), i0.ɵɵdirectiveInject(i1.GdsButtonEventsService), i0.ɵɵdirectiveInject(i2.GdsButtonModelService), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i3.DigitalDataService), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i4.GdsDataModelService), i0.ɵɵdirectiveInject(i5.GdsFilterListService), i0.ɵɵdirectiveInject(i6.GdsModalService), i0.ɵɵdirectiveInject(i7.GdsPoiService), i0.ɵɵdirectiveInject(i8.GeolocationService), i0.ɵɵdirectiveInject(i9.MsGuestsService), i0.ɵɵdirectiveInject(i10.LocaleService), i0.ɵɵdirectiveInject(i11.LocalStorageService), i0.ɵɵdirectiveInject(i12.PageLabelsResolver), i0.ɵɵdirectiveInject(i13.MsPersonalizationService), i0.ɵɵdirectiveInject(i14.GdsPictureModelService), i0.ɵɵdirectiveInject(i0.Renderer2), i0.ɵɵdirectiveInject(i15.GdsRouteResolverService), i0.ɵɵdirectiveInject(i16.GdsStateService), i0.ɵɵdirectiveInject(i17.GdsTripAdvisorService), i0.ɵɵdirectiveInject(i18.GdsCommonUtilityService), i0.ɵɵdirectiveInject(i0.ViewContainerRef), i0.ɵɵdirectiveInject(UprGdsXpmService), i0.ɵɵdirectiveInject(i20.GdsCalendarEventDayService), i0.ɵɵdirectiveInject(i20.GdsCalendarBlockoutDateService), i0.ɵɵdirectiveInject(i21.CardPromotionService), i0.ɵɵdirectiveInject(i22.NotificationService), i0.ɵɵdirectiveInject(i23.SpinnerService), i0.ɵɵdirectiveInject(i24.Router), i0.ɵɵdirectiveInject(i24.ActivatedRoute), i0.ɵɵdirectiveInject(i25.GdsInputFormService), i0.ɵɵdirectiveInject(i26.GdsInteractiveMapService), i0.ɵɵdirectiveInject(i27.GdsComparisonTableService));
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: GdsLoaderComponent,
      selectors: [["upr-gds-loader"]],
      inputs: {
        data: "data"
      },
      standalone: false,
      features: [i0.ɵɵInheritDefinitionFeature],
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function GdsLoaderComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  }
};
GdsLoaderComponent = __decorate([UprAutoSubscription(), __metadata("design:paramtypes", [Object, Object, Object, Object, Object, GdsButtonEventsService, GdsButtonModelService, ChangeDetectorRef, DigitalDataService, ElementRef, GdsDataModelService, GdsFilterListService, GdsModalService, GdsPoiService, GeolocationService, MsGuestsService, LocaleService, LocalStorageService, PageLabelsResolver, MsPersonalizationService, GdsPictureModelService, Renderer2, GdsRouteResolverService, GdsStateService, GdsTripAdvisorService, GdsCommonUtilityService, ViewContainerRef, UprGdsXpmService, GdsCalendarEventDayService, GdsCalendarBlockoutDateService, CardPromotionService, NotificationService, SpinnerService, Router, ActivatedRoute, GdsInputFormService, GdsInteractiveMapService, GdsComparisonTableService])], GdsLoaderComponent);
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(GdsLoaderComponent, [{
    type: Component,
    args: [{
      selector: 'upr-gds-loader',
      template: ` <ng-content></ng-content> `,
      changeDetection: ChangeDetectionStrategy.OnPush,
      standalone: false
    }]
  }], () => [{
    type: undefined,
    decorators: [{
      type: Inject,
      args: [WINDOW]
    }]
  }, {
    type: undefined,
    decorators: [{
      type: Inject,
      args: [DOCUMENT]
    }]
  }, {
    type: undefined,
    decorators: [{
      type: Inject,
      args: ['AppDefaults']
    }]
  }, {
    type: undefined,
    decorators: [{
      type: Inject,
      args: ['RelativeUrls']
    }]
  }, {
    type: undefined,
    decorators: [{
      type: Inject,
      args: ['DefaultValues']
    }]
  }, {
    type: i1.GdsButtonEventsService
  }, {
    type: i2.GdsButtonModelService
  }, {
    type: i0.ChangeDetectorRef
  }, {
    type: i3.DigitalDataService
  }, {
    type: i0.ElementRef
  }, {
    type: i4.GdsDataModelService
  }, {
    type: i5.GdsFilterListService
  }, {
    type: i6.GdsModalService
  }, {
    type: i7.GdsPoiService
  }, {
    type: i8.GeolocationService
  }, {
    type: i9.MsGuestsService
  }, {
    type: i10.LocaleService
  }, {
    type: i11.LocalStorageService
  }, {
    type: i12.PageLabelsResolver
  }, {
    type: i13.MsPersonalizationService
  }, {
    type: i14.GdsPictureModelService
  }, {
    type: i0.Renderer2
  }, {
    type: i15.GdsRouteResolverService
  }, {
    type: i16.GdsStateService
  }, {
    type: i17.GdsTripAdvisorService
  }, {
    type: i18.GdsCommonUtilityService
  }, {
    type: i0.ViewContainerRef
  }, {
    type: UprGdsXpmService
  }, {
    type: i20.GdsCalendarEventDayService
  }, {
    type: i20.GdsCalendarBlockoutDateService
  }, {
    type: i21.CardPromotionService
  }, {
    type: i22.NotificationService
  }, {
    type: i23.SpinnerService
  }, {
    type: i24.Router
  }, {
    type: i24.ActivatedRoute
  }, {
    type: i25.GdsInputFormService
  }, {
    type: i26.GdsInteractiveMapService
  }, {
    type: i27.GdsComparisonTableService
  }], {
    data: [{
      type: Input
    }]
  });
})();
class GdsLoaderModule {
  static {
    this.ɵfac = function GdsLoaderModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || GdsLoaderModule)();
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: GdsLoaderModule
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      providers: [GdsFilterListService],
      imports: [CommonModule, PageLabelsModule, StorageModule, GdsButtonEventsModule, GdsCalendarModule, GdsCommonUtilityModule, GdsTripAdvisorModule, MsPersonalizationModule, MsGuestModule, GdsInputFormModule, GdsInteractiveMapModule, GdsComparisonTableModule]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(GdsLoaderModule, [{
    type: NgModule,
    args: [{
      declarations: [GdsLoaderComponent],
      imports: [CommonModule, PageLabelsModule, StorageModule, GdsButtonEventsModule, GdsCalendarModule, GdsCommonUtilityModule, GdsTripAdvisorModule, MsPersonalizationModule, MsGuestModule, GdsInputFormModule, GdsInteractiveMapModule, GdsComparisonTableModule],
      exports: [GdsLoaderComponent],
      providers: [GdsFilterListService]
    }]
  }], null, null);
})();

/*
 * Public API Surface of gds-loader
 */

/**
 * Generated bundle index. Do not edit.
 */

export { GdsLoaderComponent, GdsLoaderDirective, GdsLoaderModule, UprAutoSubscription, UprGdsXpmService };
